// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2g0bc","left":"styles_left__1Re6D"};